import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ApiUrls } from '../../../constants/api-urls';

@Component({
  selector: 'app-verify-email',
  standalone: false,
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss'
})
export class VerifyEmailComponent implements OnInit {

  user: { userId: string; email: string, password: string } | undefined;
  email: string | null = null;
  resend = false;
  registerForm: FormGroup = new FormGroup({});
  private apiService = inject(ApiService);
  private fb = inject(FormBuilder);
  private toastr = inject(ToastrService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  private cd = inject(ChangeDetectorRef);
  otpConfig = {
    allowNumbersOnly: true,
    length: 6
  };

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!this.user?.email) {
      this.router.navigate(['/']);
    }
    this.email = this.user?.email || '';
    this.registerForm = this.fb.group({
      authCode: [
        '',
        [
          Validators.required,
          Validators.pattern('^\\d{6}$'),
          Validators.minLength(6),
          Validators.maxLength(6),
        ],
      ],
    });
  }

  onResend() {
    this.resend = true;
    this.apiService
      .patch(ApiUrls.Public.RESEND_VERIFICATION_EMAIL, {
        userId: this.user?.userId,
        email: this.user?.email
      })
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.message, 'Success');
            this.resend = false;
          } else {
            this.toastr.error(response.message, 'Error');
            this.resend = false;
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message || 'Bad Request', 'Error');
          this.resend = false;
        },
      });
  }

  onSubmit() {
    this.apiService
      .post(ApiUrls.Public.VERIFY_EMAIL, {
        userId: this.user?.userId,
        email: this.user?.email,
        password: this.user?.password,
        authCode: this.registerForm.get('authCode')?.value
      })
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success('Email verified successfully', 'Success');
            this.router.navigate(['/verification-complete']);
          } else {
            this.toastr.error(response.message, 'Error');
          }
        },
        error: (err) => {
          console.log(err);
          this.toastr.error(err.error.message || 'Bad Request', 'Error');
        },
      });
  }

  goBack() {
    this.location.back();
  }

  onOtpChange(event: any) {
    console.log(event);
  }
}
